// extracted by mini-css-extract-plugin
module.exports = {"customCheckbox":"WalCheckbox_customCheckbox__1U27d","inputField":"WalCheckbox_inputField__2VfMA"};